module.exports = __webpack_public_path__ + "media/images/lb/577-2554617449f8d3d897459e76b8535975.svg";